/**
 * Description: 首问卡片
 * User: <changyin>
 * Date: 2017-01-04
 * Copyright(c) 2017 Taobao.com
 * update:
 *  2017-01-04 @changyin 重构
 */

import FirstMessage from './firstmessage';

export default function (app, done) {
  const firstmsg = new FirstMessage(app);
  firstmsg.on('load', () => {
    done();
  });
  window.alicare_firstmessage = firstmsg;
}




// WEBPACK FOOTER //
// ./src/app/module/firstmessage/index.js